import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { RestApi } from "src/app/shared/RestApi/restApi";

interface MigrationJsonsServiceInfo {
  statusMessage: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class MigrationJsonsService {

  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi
  ) { }

  async insertService(screenCreatorData) {

    console.log(screenCreatorData);

    this.spinner.start();

    let response = await this.http.post<MigrationJsonsServiceInfo>(this.restAPI.INSERT_MIGRATION_JSONS_URL, screenCreatorData, { headers: this.headers }).toPromise();

    //Printing the response.
    console.log(response);

    this.spinner.stop();

    this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
  }

}
